<template>
  <IconMaterial title="opacity" :size="size" />
</template>

<script>
  import IconMaterial from '@/uikitBase/icons/IconMaterial';

  export default {
    name: 'IconSample',

    components: {
      IconMaterial,
    },

    props: {
      size: {
        type: Number,
        default: 16,
      },
    },
  };
</script>
